import { render } from "./ConfigureShiftsCard.vue?vue&type=template&id=4d94bfcc"
import script from "./ConfigureShiftsCard.vue?vue&type=script&lang=js"
export * from "./ConfigureShiftsCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__